import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

export default function CallModal({ patient, onClose, onConfirm }) {
  const phone = patient.phone_number || patient.phone;

  // Close on Escape
  useEffect(() => {
    function handleKey(e) { if (e.key === 'Escape') onClose(); }
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onClose]);

  return createPortal((
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" style={{ maxWidth: 420 }} onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div className="modal-header">
          <h2 className="header3" style={{ margin: 0 }}>Contact Patient</h2>
          <button className="modal-close" onClick={onClose} aria-label="Close">&times;</button>
        </div>

        {/* Recipient + phone fields (read-only) */}
        <div className="call-modal-body">
          <div className="rx-field">
            <label className="eyebrow text-secondary">Recipient</label>
            <input
              className="rx-input"
              readOnly
              disabled
              value={`${patient.firstname} ${patient.lastname}`}
              style={{ textTransform: 'capitalize' }}
            />
          </div>

          <div className="rx-field">
            <label className="eyebrow text-secondary">Phone number</label>
            <input
              className="rx-input"
              readOnly
              disabled
              value={phone || 'No phone number on file'}
              style={!phone ? { color: 'var(--wi-status-moderate)', fontStyle: 'italic' } : {}}
            />
          </div>
        </div>

        {/* Actions */}
        <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 20 }}>
          <button className="btn-secondary" onClick={onClose}>Cancel</button>
          <button
            className="btn-primary"
            disabled={!phone}
            onClick={() => { onConfirm(); onClose(); }}
            style={{ minWidth: 80 }}
          >
            Call
          </button>
        </div>
      </div>
    </div>
  ), document.body);
}
